var domain = function (param) {
  if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'testbuild' || process.env.NODE_ENV == 'test') {
    return param.prod;
  }
  if (process.env.NODE_ENV == 'dev') {
    return param.prod;
  }
  if (process.env.NODE_ENV == 'production') {
    return param.prod;
  }
}

module.exports = {
  "/gateway": {
    target: domain({
      dev: "http://liefeng-gateway.test.gongxiangplat.com",
      test: "http://liefeng-gateway.test.gongxiangplat.com",
      prod: "https://api.gateway.prod.liefengtech.com",
    }),
    ws: false,
    changeOrigin: true,
    secure: true,
  },
  /**
   * lf-resident：context-path=/resident，端口 9581
   * request.js 非 test 会把 target 当作绝对前缀直连（需带 /resident）
   */
  "/resident": {
    target: (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "dev")
      ? "https://api.gateway.prod.liefengtech.com/resident"
      : domain({
          dev: "https://api.gateway.prod.liefengtech.com/resident",
          test: "https://api.gateway.prod.liefengtech.com/resident",
          prod: "https://api.gateway.prod.liefengtech.com/resident",
        }),
    ws: false,
    changeOrigin: true,
    secure: false,
  },
}